var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Manage_box"},[_c('div',{staticClass:"box_left"},[_c('WorkHeader',{on:{"selectAccountData":_vm.selectAccountData}}),_c('div',{staticClass:"show_box"},[_c('router-view',{attrs:{"accountId":_vm.accountId}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }